
<div class="outer ">

<div class="text-center mb-1 mt-5">
  <h1 class="fw-bolder" style="color: #273C66;
      font-size: 1.9rem;
      font-family: 'Poppins', sans-serif;
      letter-spacing: 2px;
      text-decoration: underline;
      text-decoration-color: red;
      text-underline-offset: 5px;">
    Our Mutual Fund Partners
  </h1>
</div>


  <div class="slider-wrapper">
    <div class="slider-track">

      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (2).png" alt="image not found" />
      </div>

      <div class="slide">
        <img  src="assets\SNP_Partner_logo\tata.png" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (5).png" alt="image not found" />
      </div>


      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (9).png" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (10).png" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (11).png" alt="image not found" />
      </div>


      <div class="slide">
        <img  src="assets\SNP_Partner_logo\Snp_partner_logo (14).png" alt="image not found" />
      </div>




      <div class="slide">
        <img  src="assets\SNP_Partner_logo\edmutual.svg" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\IDBImf.jpg" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\hsbc-mutual-fund.png" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\icicpudentel24.jpeg.jpg" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\iiflmutual25.png" alt="image not found" />
      </div>

      <div class="slide">
        <img  src="assets\SNP_Partner_logo\BNP Paribas 27.webp" alt="image not found" />
      </div>

      <div class="slide">
        <img  src="assets\SNP_Partner_logo\baroda28.png" alt="image not found" />
      </div>

      <div class="slide">
        <img  src="assets\SNP_Partner_logo\mirae-asset-mutual-fund-logo29.jpg" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\moamc-mf-logo-30.webp" alt="image not found" />
      </div>
      <div class="slide">
        <img  src="assets\SNP_Partner_logo\boi_groww31.webp" alt="image not found" />
      </div>


    </div>
  </div>

</div>
<div class="webinar-section mt-5">
  <h2 class="webinar-title">Join Our Webinar</h2>

  <div class="webinar-details ">
    <p><span>Date:</span> Every Saturday</p>
    <p><span>Time:</span> 7:30 PM (IST)</p>
    <p><span>Topic:</span> How to Plan and Retire Early With SIP/Mutual Fund Investment</p>
  </div>
  <button class="webinar-button" (click)="joinWebinar()">Join Webinar</button>
</div>



